import React from 'react';
import { Button, Card, message, Popconfirm, Space, Tabs } from 'antd';
import AttendanceAdjustment from './attendance-adjustment';
import AttendanceExcel from './attendance-excel'
import { AttendanceService } from '@gtpl/shared-services/hrms';
import { RetweetOutlined } from '@ant-design/icons';

const { TabPane } = Tabs;

const AttendanceTabs = () => {
  const attnService = new AttendanceService();

  const updateAttendanceStatus = () =>{
    attnService.updateAttendanceStatus().then((res)=>{
      if(res.success == true){
        message.success(res.message,2)
      }else{
        message.error(res.message,3)
      }
    }).catch((err)=>{
      message.error(err,2)
    })
  }

  const updateWOAttendanceStatus = () =>{
    attnService.updateWOAttendanceStatus().then((res)=>{
      if(res.data.status == true){
        message.success(res.data.internalMessage,2)
      }else{
        message.error(res.data.internalMessage,3)
      }
    }).catch((err)=>{
      message.error(err,2)
    })
  }

  const updatePHAttendanceStatus = () =>{
    attnService.updatePHAttendanceStatus().then((res)=>{
      if(res.data.status == true){
        message.success(res.data.internalMessage,2)
      }else{
        message.error(res.data.internalMessage,3)
      }
    }).catch((err)=>{
      message.error(err,2)
    })
  }


  return (
    <Tabs defaultActiveKey="1" type="card" >
      <TabPane tab={<span style={{fontWeight:'bolder'}}>Excel Upload</span>} key="1">
        <AttendanceExcel />
      </TabPane>
      <TabPane tab={<span style={{fontWeight:'bolder'}}>Manual Entry</span>} key="2">
        <AttendanceAdjustment isUpdate={false} applyForLeavesData={undefined} updateDetails={undefined} closeForm={() => { }}/>
      </TabPane>
      <TabPane tab={<span style={{fontWeight:'bolder'}}>Update Attendance</span>} key="3">
        <Card 
        title={<span style={{ color: 'white' }}>Update Attendance</span>}
        headStyle={{ backgroundColor: '#69c0ff', border: 0 }}
        style={{ textAlign: 'center' }}
        >
           <Space size="middle" style={{ width: '100%', justifyContent: 'center'}}>
           <Popconfirm title={'Are you Adjusting previous attendance status updating Are you sure about updating?'} onConfirm={updateAttendanceStatus} placement="bottomRight">
            <Button style={{fontWeight:'bold'}} block>
              <RetweetOutlined /> Attendance Adjustment
            </Button>
          </Popconfirm>
           <Popconfirm title={'Are you updating Week off status "WO" to "A" if employee not present before and after 2 days Not Present'} onConfirm={updateWOAttendanceStatus} placement="bottom">
            <Button style={{fontWeight:'bold'}} block>
              <RetweetOutlined /> WeekOff's Adjustment
            </Button>
          </Popconfirm> 
           <Popconfirm title={'Are you updating Week off status "PH" to "A" if employee not present before and after 2 days Not Present '} onConfirm={updatePHAttendanceStatus} placement="bottomLeft">
            <Button style={{fontWeight:'bold'}} block>
              <RetweetOutlined /> Public Holiday's Adjustment
            </Button>
          </Popconfirm>
          </Space>
        </Card>
      </TabPane>
    </Tabs>
  );
};

export default AttendanceTabs;